import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=07c1197b&scoped=true&"
import script from "./Hero.vue?vue&type=script&lang=js&"
export * from "./Hero.vue?vue&type=script&lang=js&"
import style0 from "./Hero.vue?vue&type=style&index=0&id=07c1197b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c1197b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ContributorSignUpLink: require('/opt/render/project/src/channels2022/src/components/contributor/signup/ContributorSignUpLink.vue').default})
